import { ReactNode } from 'react'

import { Panel } from '@/ui/atoms/panel/Panel'

interface StatusPanelGridProps {
  children: ReactNode
}

export function StatusPanelGrid({ children }: StatusPanelGridProps) {
  return <Panel className="grid grid-cols-[min-content_1fr_auto] items-center gap-x-2.5 sm:gap-x-5">{children}</Panel>
}
